module.exports = __webpack_public_path__ + "img/questioninvalid.24f2f368.svg";